import { NgModule } from '@angular/core';
import { JoinerPipe } from './joiner.pipe';
import { FormatPhoneNumber } from './format-phonenumber';
import { FilterArrayPredicatePipe } from './pipes/filter-array-predicate.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { AlternativeDisplayPipe } from './pipes/alternative-display.pipe';
import { AssetSourcePipe } from './pipes/asset-source.pipe';
import { GoogleStreetviewLinkPipe } from './pipes/google-streetview-link.pipe';
import { ExEditAdjustmentStringsPipe } from '../../components/ex-edit-adjustment/ex-edit-adjustment-strings/ex-edit-adjustment-strings.pipe';
import { FormatMoment } from '../../pipes/format-moment';
import { PrintAddressPipe } from '../../pipes/print-address.pipe';
import { ProductTypePipe } from '../../pipes/product-type.pipe';
import { OverviewProjectTypePipe } from '../../pipes/overview-project-type.pipe';
import { OverviewProjectTypeClassPipe } from '../../pipes/overview-project-type-class.pipe';
import { AbbreviatedProductTypePipe } from '../../pipes/abbreviated-product-type.pipe';
import { FormatDate } from '../../pipes/format-date';
import { MaterialOrAlternativePipe } from './pipes/label-or-alternative/material-or-alternative.pipe';
import { PlacementTypeOrAlternativePipe } from './pipes/label-or-alternative/placement-type-or-alternative.pipe';
import { ColorOrAlternativePipe } from './pipes/label-or-alternative/color-or-alternative.pipe';
import { FormatDecimal } from '../../pipes/format-decimal';
import { ShortenTextPipe } from '../../pipes/shorten-text.pipe';
import { OrPipe } from '../../pipes/or.pipe';
import { SubstringPipe } from './pipes/substring.pipe';
import { DistanceToBottomDisplayPipe } from './pipes/distance-to-bottom-display.pipe';
import { MultiplyPipe } from '../../pipes/multiply.pipe';
import { MailSubjectBodyLinkPipe } from '../../pipes/mail-subject-body-link.pipe';
import { SignStickerTypeOrAlternativePipe } from './pipes/label-or-alternative/sign-sticker-type-or-alternative';
import { ShortenTextSplitOnPipe } from '../../pipes/shorten-text-split-on';
import { FormatBoolean } from '../../pipes/format-boolean.pipe';
import { FormatIPBoardDimensionsPipe } from './pipes/ip-board/format-ip-board-dimensions.pipe';
import { DisplayIPBoardTypePipe } from './pipes/ip-board/display-ip-board-type.pipe';
import { DisplayIPBoardAssociationPipe } from './pipes/ip-board/display-ip-board-association.pipe';
import { FormatASAPDate } from '../../pipes/format-asap-date';
import { FormatProductSizePipe } from '../../pipes/format-product-size.pipe';
import { SumPipe } from '../../pipes/sum.pipe';
import { DisplayConditionalStringPipe } from './pipes/display-conditional-string.pipe';
import { GoogleMapsAddressRequest } from '../../pipes/google-maps-address-request.pipe';
import { FormatSummaryTime } from '../../pipes/format-summary-time-budget';
import { NoEmptyProjectContactsPipe } from '../../pipes/no-empty-project-companies';
import { IPBoardPlacementTypeOrAlternativePipe } from './pipes/label-or-alternative/ip-board-placement-type-or-alternative.pipe';
import { PrintASAPDateFormat } from './pipes/print-asap-date-format';
import { FilterProductAssetsPipe } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/design-card/design-card.component';
import {
  ProductPlacementConfigPipe,
  ProductStockConfigPipe,
  ProductTypeConfigPipe
} from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/configuration-card/configuration-card.component';
import { ProductTitleSummaryPipe } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-summary/client-adjustment-summary.component';
import {
  NullCheckPipe,
  ReducePipe
} from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/facturation-card/facturation-card.component';
import { WazeLinkPipe } from '../../pipes/waze-link.pipe';
import { StockSignMeasurementsPipe } from '../../pipes/stock-sign-measurements.pipe';
import {
  FormatAppointmentTooltipPipe,
  FormatKeyTooltipPipe
} from '../../pipes/format-appointment-tooltip.pipe';
import { IPBoardMeasurementPipe } from '../../shared/project-components/client-project-form/base-project/client-ip-board-form/client-ip-board-form.component';
import { ReverseIterablePipe } from './pipes/reverse-iterable';

@NgModule({
  imports: [],
  exports: [
    JoinerPipe,
    FormatPhoneNumber,
    FilterArrayPredicatePipe,
    CapitalizePipe,
    AlternativeDisplayPipe,
    AssetSourcePipe,
    GoogleStreetviewLinkPipe,
    ExEditAdjustmentStringsPipe,
    FormatMoment,
    PrintAddressPipe,
    ProductTypePipe,
    OverviewProjectTypePipe,
    OverviewProjectTypeClassPipe,
    AbbreviatedProductTypePipe,
    FormatDate,
    MaterialOrAlternativePipe,
    PlacementTypeOrAlternativePipe,
    ColorOrAlternativePipe,
    FormatDecimal,
    ShortenTextPipe,
    OrPipe,
    SubstringPipe,
    DistanceToBottomDisplayPipe,
    MultiplyPipe,
    MailSubjectBodyLinkPipe,
    SignStickerTypeOrAlternativePipe,
    ShortenTextSplitOnPipe,
    FormatBoolean,
    FormatIPBoardDimensionsPipe,
    DisplayIPBoardTypePipe,
    DisplayIPBoardAssociationPipe,
    FormatASAPDate,
    FormatProductSizePipe,
    SumPipe,
    DisplayConditionalStringPipe,
    GoogleMapsAddressRequest,
    FormatSummaryTime,
    NoEmptyProjectContactsPipe,
    IPBoardPlacementTypeOrAlternativePipe,
    PrintASAPDateFormat,
    FilterProductAssetsPipe,
    ProductPlacementConfigPipe,
    ProductStockConfigPipe,
    ProductTypeConfigPipe,
    ProductTitleSummaryPipe,
    IPBoardMeasurementPipe,
    ReducePipe,
    NullCheckPipe,
    WazeLinkPipe,
    StockSignMeasurementsPipe,
    FormatAppointmentTooltipPipe,
    FormatKeyTooltipPipe,
    ReverseIterablePipe
  ],
  declarations: [
    JoinerPipe,
    FormatPhoneNumber,
    FilterArrayPredicatePipe,
    CapitalizePipe,
    AlternativeDisplayPipe,
    AssetSourcePipe,
    GoogleStreetviewLinkPipe,
    ExEditAdjustmentStringsPipe,
    FormatMoment,
    PrintAddressPipe,
    ProductTypePipe,
    OverviewProjectTypePipe,
    OverviewProjectTypeClassPipe,
    AbbreviatedProductTypePipe,
    FormatDate,
    MaterialOrAlternativePipe,
    PlacementTypeOrAlternativePipe,
    ColorOrAlternativePipe,
    FormatDecimal,
    ShortenTextPipe,
    OrPipe,
    SubstringPipe,
    DistanceToBottomDisplayPipe,
    MultiplyPipe,
    MailSubjectBodyLinkPipe,
    SignStickerTypeOrAlternativePipe,
    ShortenTextSplitOnPipe,
    FormatBoolean,
    FormatIPBoardDimensionsPipe,
    DisplayIPBoardTypePipe,
    DisplayIPBoardAssociationPipe,
    FormatASAPDate,
    FormatProductSizePipe,
    SumPipe,
    DisplayConditionalStringPipe,
    GoogleMapsAddressRequest,
    FormatSummaryTime,
    NoEmptyProjectContactsPipe,
    IPBoardPlacementTypeOrAlternativePipe,
    PrintASAPDateFormat,
    FilterProductAssetsPipe,
    ProductPlacementConfigPipe,
    ProductStockConfigPipe,
    ProductTypeConfigPipe,
    ProductTitleSummaryPipe,
    IPBoardMeasurementPipe,
    ReducePipe,
    NullCheckPipe,
    WazeLinkPipe,
    StockSignMeasurementsPipe,
    FormatAppointmentTooltipPipe,
    FormatKeyTooltipPipe,
    ReverseIterablePipe
  ],
  providers: [NoEmptyProjectContactsPipe]
})
export class AppPipesModule {}
